/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserDocumentDto } from '../../models/user-document-dto';

export interface FindUserDocuments$Params {
  userId: number;
  userVerificationId?: number;
  'X-API-Version'?: string;
}

export function findUserDocuments(http: HttpClient, rootUrl: string, params: FindUserDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserDocumentDto>>> {
  const rb = new RequestBuilder(rootUrl, findUserDocuments.PATH, 'get');
  if (params) {
    rb.query('userId', params.userId, {});
    rb.query('userVerificationId', params.userVerificationId, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserDocumentDto>>;
    })
  );
}

findUserDocuments.PATH = '/api/user-documents';
